import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/shared/hooks/useAuth';
import { AuthLoading } from './AuthLoading';
import { useHomeRoute } from '@/shared/hooks/useHomeRoute';

/**
 * Redirects authenticated users away from auth and landing pages: to the
 * inbox for a single brand, to the overview for an agency.
 */
export function GuestGuard() {
  const { isLoading, isAuthenticated } = useAuth();
  const home = useHomeRoute();

  if (isLoading) return <AuthLoading />;
  if (isAuthenticated) return <Navigate to={home} replace />;

  return <Outlet />;
}
